import { render } from "./EditDistancePage.vue?vue&type=template&id=a6a0827c&ts=true"
import script from "./EditDistancePage.vue?vue&type=script&lang=ts"
export * from "./EditDistancePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__